





















import { defineComponent, ref, computed } from "@vue/composition-api";
import NoteModel from "@/ts/models/noteClass";
import NotePopup from "@c/molecules/note/NotePopup.vue";
export default defineComponent({
  name: "NoteCard",

  components: {
    NotePopup
  },

  props: {
    note: Object as () => NoteModel,
    withPlace: {
      type: Boolean,
      default: false
    }
  },

  setup() {
    var show = ref(false);

    return {
      show
    };
  }
});
